import React from "react";
import "./shared.css";

export default function PageHeader({ title, subtitle, actions }) {
  return (
    <div className="page-header-shared">
      <div className="page-header-content">
        <h1 className="page-header-title">{title}</h1>
        {subtitle && <p className="page-header-subtitle">{subtitle}</p>}
      </div>
      {actions && <div className="page-header-actions">{actions}</div>}
    </div>
  );
}
